

export const ADOBE = {
    ADOBE_HOST: process.env.REACT_APP_ADOBE_HOST,
    ADOBE_CLIENT_ID: process.env.REACT_APP_ADOBE_CLIENT_ID,
}




// WEBPACK FOOTER //
// ./src/sub-projects/adobe/constants/index.tsx